import React from 'react'
import PropTypes from 'prop-types'

const GeneralRemiderTypeIcon = (props) => {
  const { width = 20, height = 20, fill = '#183560' } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        minHeight: '20px',
        minWidth: '20px',
      }}
    >
      <g clipPath="url(#clip0_2313_1999)">
        <path
          d="M9.16602 5.83268H10.8327V7.49935H9.16602V5.83268ZM9.16602 9.16602H10.8327V14.166H9.16602V9.16602ZM9.99935 1.66602C5.39935 1.66602 1.66602 5.39935 1.66602 9.99935C1.66602 14.5993 5.39935 18.3327 9.99935 18.3327C14.5993 18.3327 18.3327 14.5993 18.3327 9.99935C18.3327 5.39935 14.5993 1.66602 9.99935 1.66602ZM9.99935 16.666C6.32435 16.666 3.33268 13.6743 3.33268 9.99935C3.33268 6.32435 6.32435 3.33268 9.99935 3.33268C13.6743 3.33268 16.666 6.32435 16.666 9.99935C16.666 13.6743 13.6743 16.666 9.99935 16.666Z"
          fill={fill}
        />
        <path
          d="M14.5938 19.6875C13.6852 19.6875 12.797 19.4181 12.0416 18.9133C11.2862 18.4085 10.6974 17.6911 10.3497 16.8517C10.002 16.0123 9.91102 15.0887 10.0883 14.1976C10.2655 13.3065 10.703 12.4879 11.3455 11.8455C11.9879 11.203 12.8065 10.7655 13.6976 10.5883C14.5887 10.411 15.5123 10.502 16.3517 10.8497C17.1911 11.1974 17.9085 11.7862 18.4133 12.5416C18.9181 13.297 19.1875 14.1852 19.1875 15.0938C19.1875 16.3121 18.7035 17.4805 17.842 18.342C16.9805 19.2035 15.8121 19.6875 14.5938 19.6875ZM14.5938 11.6484C13.9123 11.6484 13.2462 11.8505 12.6796 12.2291C12.1131 12.6077 11.6715 13.1457 11.4107 13.7753C11.1499 14.4048 11.0817 15.0976 11.2146 15.7659C11.3476 16.4342 11.6757 17.0481 12.1575 17.53C12.6394 18.0118 13.2533 18.3399 13.9216 18.4729C14.5899 18.6058 15.2827 18.5376 15.9122 18.2768C16.5418 18.016 17.0798 17.5744 17.4584 17.0079C17.837 16.4413 18.0391 15.7752 18.0391 15.0938C18.0391 14.18 17.6761 13.3037 17.03 12.6575C16.3838 12.0114 15.5075 11.6484 14.5938 11.6484Z"
          fill={fill}
        />
        <path
          d="M14.5938 11.6484C13.9123 11.6484 13.2462 11.8505 12.6796 12.2291C12.1131 12.6077 11.6715 13.1457 11.4107 13.7753C11.1499 14.4048 11.0817 15.0976 11.2146 15.7659C11.3476 16.4342 11.6757 17.0481 12.1575 17.53C12.6394 18.0118 13.2533 18.3399 13.9216 18.4729C14.5899 18.6058 15.2827 18.5376 15.9122 18.2768C16.5418 18.016 17.0798 17.5744 17.4584 17.0079C17.837 16.4413 18.0391 15.7752 18.0391 15.0938C18.0391 14.18 17.6761 13.3037 17.03 12.6575C16.3838 12.0114 15.5075 11.6484 14.5938 11.6484Z"
          fill="#FEFEFE"
        />
        <path
          d="M11.9027 19.1212C12.6993 19.6534 13.6357 19.9375 14.5938 19.9375C15.8784 19.9375 17.1104 19.4272 18.0188 18.5188C18.9272 17.6104 19.4375 16.3784 19.4375 15.0938C19.4375 14.1357 19.1534 13.1993 18.6212 12.4027C18.0889 11.6062 17.3325 10.9853 16.4474 10.6187C15.5623 10.2521 14.5884 10.1562 13.6488 10.3431C12.7092 10.53 11.8461 10.9913 11.1687 11.6687C10.4913 12.3461 10.03 13.2092 9.84307 14.1488C9.65618 15.0884 9.7521 16.0623 10.1187 16.9474C10.4853 17.8325 11.1062 18.5889 11.9027 19.1212Z"
          stroke="#FEFEFE"
          strokeWidth="0.5"
        />
        <path
          d="M15.5068 17.3164L14.0195 15.8292V13.2969H15.168V15.3583L16.3164 16.5068L15.5068 17.3164Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2313_1999">
          <rect width="20" height="20" fill="none" />
        </clipPath>
      </defs>
    </svg>
  )
}

GeneralRemiderTypeIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}
export default GeneralRemiderTypeIcon
